<template>
   <div>
      <div v-if="objPedido && pagamentoPendente && (formaPagamento === 'PIX' || formaPagamento === 'BOLETO')">
        <StepPix
          v-if="formaPagamento === 'PIX'"
          :pedidoId="pedidoId"
          :tipo="'marketplace'"></StepPix>
        <StepBoleto
          v-if="formaPagamento === 'BOLETO'"
          :pedidoId="pedidoId" :tipo="'marketplace'" :colSize="colSize"></StepBoleto>
      </div>
      <div v-if="objPedido && !pagamentoPendente">
        <div>
          {{this.objPedido.status}}
        </div>
      </div>
      <div class="card aviso px-3 mt-4 d-block py-2 border-0" v-if="objPedido && pagamentoPendente && !this.objPedido.pagamento.metodo">
        <div class="text-center" >
          <b> Instruções para realizar o pagamento. </b>
          <br />
          <br />
          <span>
            Para finalizar o pedido selecione uma forma de pagamento e realize o pagamento.
          </span>
        </div>
      </div>
      <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">        
        <button class="btn col btn_color_system mt-4 py-2" type="button" @click="alterarFormaPagamento()" v-if="objPedido && pagamentoPendente && !this.objPedido.pagamento.metodo">
          SELECIONAR FORMA PAGAMENTO
        </button>
      </div>
    </div>
    
</template>

<script>
import StepBoleto from "../assinaturas/StepBoleto.vue";
import StepPix from "../assinaturas/StepPix.vue";

export default {
  name: "DetalhePagamentoPedido",
  components: {
    StepBoleto,
    StepPix
  },
  props: ["objPedido", "colSize"],
  data() {
    return {
      URL_SLUG: window.URL_SLUG,
      codigoRede: window.APP_ORIGIN,
      modeloCobranca: null,
      formaPagamento: '',
      pedidoId: null,
      pagamentoPendente: null
    };
  },
  mounted() {
    if(this.objPedido.pagamento) {
      this.pedidoId = this.objPedido.id;
      this.pagamentoPendente = this.objPedido.status === 'AGUARDANDO_CHECKOUT';
      
      if (this.objPedido.pagamento.metodo === "PIX") {
        this.formaPagamento = "PIX";
      } else if(this.objPedido.pagamento.metodo === "BOLETO") {
        this.formaPagamento = "BOLETO";
      }
    }
  },
  methods: {
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    alterarFormaPagamento() {
      this.$router.push(`/carrinho/${this.pedidoId}`);
    }
  }
}
</script>
<style scoped lang="scss">
.pagamentoCartao {
  position: relative;
  height: 600px;
}

.endereco {
  position: absolute;
  top: -46px;
  left: 0;
  background-color: #f2f2f2;
  width: 100%;
  height: 685px;
  overflow: auto;
  z-index: 2;
}

.card {
  border-radius: 10px;
  position: relative;

  &.aviso {
    background-color: #dfdfdf;
  }
}
</style>
